import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloUFDestino } from "../models/ufDestino";
import { Repositorio } from "./repositorio";

export class RepositorioUFDestino extends Repositorio<ModeloUFDestino> {
  constructor() {
    super(ConstanteGlobal.UF_DESTINO);
  }
}
